'use strict';

const _ = require('underscore');
const i18n = require('i18next');
require('backbone.stickit');
const Logger = require('common/util/logger');
const UserAPI = require('common/infra/api/user');
const UserModel = require('common/domain/entity/user');
const UserEmailCollection = require('common/domain/collection/user-email');
const ModalBaseView = require('common/ui/view/modal/base');
const UserEmailListView = require('common/ui/view/modal/user-email-list');
const Template = require('common/ui/template/modal/user-signup.hbs');

module.exports = ModalBaseView.extend({
    model: UserModel,
    template: Template,

    modelEvents: {
        'change': 'onInputValidation'
    },

    bindings: {
        'input.name': 'name',
        'select.language': {
            observe: 'language',
            selectOptions: {
                collection: UserModel.languages,
                labelPath: 'label',
                valuePath: 'value'
            }
        },
        'input.mail_address': 'mail_address',
        'input.organization': 'organization'
    },

    initialize: function() {
        _.bindAll(this, 'setting', 'success', 'error');
        if (!this.model.get('language')) {
            this.model.set('language', 'ja');
        }
    },

    onRender: function() {
        this.stickit();
        this.setupModal();

        this.$mailMagazineReceive = this.$('input.mail_magazine_receive');
        this.$eulaAgreement = this.$('input.eula_agreement');

        this.emailAddressListView = new UserEmailListView({collection: this.model.getEmails()});
        this.$('.mail_address_list').html(this.emailAddressListView.render().el);

        this.$('.modal').on('shown.bs.modal', () => {
            $.material.init();
        });

        return this;
    },

    onAttach: function() {
        this.$eulaAgreement.on('change', () => {
            this.model.set({'eulaAgreement': this.$eulaAgreement.is(':checked')});
        });
    },

    setting: function() {
        return new Promise((resolve, reject) => {
            const isValid = this.model.isValid(true);
            const isMailAddressListValid = _.all(
                this.model.getEmails().map(function(m) { return m.isValid(true); })
            );

            if(!isValid || !isMailAddressListValid) {
                Logger.warn('UserSignup ValidationError:', this.model.validationError);
                return false;
            }

            const json = this.model.editableAttributes();
            json.mail_magazine_receive = this.$mailMagazineReceive.is(':checked');
            json['mail_address_list'] = this.model.getEmails().filter(function(m) {
                return m.get('mail_address').length > 0;
            }).map(function(m) {
                return m.toJSON();
            });

            UserAPI.createUser(json)
                .then(
                    () => {
                        this.success();
                        resolve();
                    },
                    (xhr) => {
                        this.error(this.model, xhr);
                        reject();
                    }
                );
        });
    },

    success: function() {
        const urlParams = new URLSearchParams(location.search);
        const dstUrl = urlParams.get('dst_url');
        if(dstUrl) {
            location.href = decodeURIComponent(dstUrl);
        } else {
            location.href = '/';
        }
    },

    onInputValidation: function () {
        if(this.model.get('name') && this.model.get('eulaAgreement')) {
            this.trigger('formFilled');
        } else {
            this.trigger('formEmpty');
        }
    },

    error: function(model, xhr) {
        if (xhr && xhr.type == 'DuplicateEmailError') {
            this.model.trigger('validated:invalid', this.model, {
                mail_address: 'input.user.mail_address.validation.duplicated'
            });
        }else if (xhr && xhr.type == 'InvalidUserNameError') {
            this.$('.name .alert-message').html(
                i18n.t('input.user.name.validation.invalid')
            );
        }
        Logger.error('error', xhr);
    }
});




// WEBPACK FOOTER //
// ./common/ui/view/modal/user-signup.js